define('store/reducers/server',["exports", "../actions/types"], function (exports, _types) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });


    var initialState = {
        realm: undefined
    }; /**
        * The contents of this file are subject to the terms of the Common Development and
        * Distribution License (the License). You may not use this file except in compliance with the
        * License.
        *
        * You can obtain a copy of the License at legal/CDDLv1.0.txt. See the License for the
        * specific language governing permission and limitations under the License.
        *
        * When distributing Covered Software, include this CDDL Header Notice in each file and include
        * the License file at legal/CDDLv1.0.txt. If applicable, add the following below the CDDL
        * Header, with the fields enclosed by brackets [] replaced by your own identifying
        * information: "Portions copyright [year] [name of copyright owner]".
        *
        * Copyright 2016 ForgeRock AS.
        */

    var server = function server() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var action = arguments[1];

        switch (action.type) {
            case _types.SERVER_ADD_REALM:
                return { realm: action.realm.toLowerCase() };
            default:
                return state;
        }
    };

    exports.default = server;
});

